import script from "./LivePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LivePanel.vue?vue&type=script&setup=true&lang=js"

import "./LivePanel.vue?vue&type=style&index=0&id=5487e722&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5487e722"]])

export default __exports__